import mutations from './mutations';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";
import { DataService } from '../../../../config/dataService/dataService';
import { notification } from 'ant-design-vue';
import { setCookie, getAccessToken } from '../../../../utility/cookieStorage';
import axios from 'axios';
import { cambiarIdioma } from '@/i18n';

const state = () => ({
    accessToken: getAccessToken() || null,
    login: !!getAccessToken(),
    loading: false,
    error: null,
});

const cleanSignInData = () => {
    Cookies.remove('accessToken');
    Cookies.remove('user');
    localStorage.clear();
    sessionStorage.clear();
}

const actions = {
    async login({ commit }, payload) {
        try {
            await commit('loginBegin');
            // form-data post request
            const formData = new FormData();
            formData.append('email', payload.email);
            formData.append('password', payload.password);

            await DataService.post(`/login`, formData, {
                'Content-Type': 'application/x-www-form-urlencoded',
            }).then((response) => {
                if (response.data && response.data.success === true) {
                    const accessToken = response.data.accessToken;
                    setCookie('accessToken', accessToken);

                    // El idioma que esta persona eligio la ultima vez, aunque
                    // sea desde otro equipo. En un navegador nuevo no hay nada
                    // guardado, asi que sin esto el CRM le arrancaria en el
                    // idioma por defecto y no en el suyo. Se recuerda tambien
                    // en el navegador, que es de donde lo lee la interfaz.
                    if (response.data.language) {
                        cambiarIdioma(response.data.language);
                    }

                    commit('loginSuccess', accessToken);

                    notification.success({
                        message: 'Successfully logged in',
                        placement: 'topRight'
                    });

                } else {
                    notification.error({
                        message: 'Invalid email or password.',
                        placement: 'topRight'
                    });
                }
            }).catch((err) => {
                console.log(err);
                notification.error({
                    message: 'Invalid email or password.',
                    placement: 'topRight'
                });

                commit('loginErr', err);
            });

        } catch (err) {
            await commit('loginErr', err);
        }
    },

    async googleLogin({ commit }, token) {
        try {
            await commit('loginBegin');

            await axios.post('/api/auth/google/callback', { token })
            .then((response) => {
                if (response.data && response.data.success === true) {
                    const accessToken = response.data.accessToken;
                    setCookie('accessToken', accessToken);

                    commit('loginSuccess', accessToken);

                    notification.success({
                        message: 'Successfully logged in',
                        placement: 'topRight'
                    });
                }
            }).catch((err) => {
                console.log('Google login error: ', err);
            });
        } catch (err) {
            console.log('Google login error: ', err);
        }
    },

    async userPermissions({ commit }) {
        // send request for user permissions and
        // store the user with permissions available
        await DataService.get(`/user-permissions`).then((response) => {
                const permissions = response.data.data.list;
                const accessToken = getAccessToken();
                const user = jwtDecode(accessToken);
                user.permissions = permissions;

                setCookie('user', JSON.stringify(user));

                commit('loginSuccess', accessToken);
        }).catch((err) => {
            console.log('Permission error: ', err);
        });
    },

    async logOut({ commit }) {
        commit('logoutBegin');
        await DataService.post(`/logout`, {}).then(() => {
            cleanSignInData();
            commit('logoutSuccess', null);
        }).catch((err) => {
            commit('logoutErr', err);
            cleanSignInData();
            commit('logoutSuccess', null);
        });
    },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
};
